import { Link } from 'react-router-dom';
import { Container } from './Container';
import { BrandLockup } from './BrandLockup';

const year = new Date().getFullYear();

const legal = [
  { to: '/legal/client-agreement', label: 'Client Agreement' },
  { to: '/legal/parental-consent', label: 'Parental Consent' },
  { to: '/legal/scope-of-coaching', label: 'Scope of Coaching' },
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
];

const sitemap = [
  { to: '/about', label: 'About' },
  { to: '/programs', label: 'Programs' },
  { to: '/programs/own-your-lane', label: 'Own Your Lane' },
  { to: '/programs/own-your-future', label: 'Own Your Future' },
  { to: '/programs/light-your-lane', label: 'Strength Within' },
  { to: '/book-consult', label: 'Book a Free Consult' },
  { to: '/contact', label: 'Contact' },
];

export function Footer() {
  return (
    <footer className="mt-24 bg-[var(--color-ink)] text-[var(--color-cream)]">
      <Container className="grid gap-12 py-16 md:grid-cols-12">
        <div className="md:col-span-5">
          <BrandLockup variant="inverse" />
          <p className="lede mt-6 max-w-prose text-[var(--color-cream)]/80">
            Student success coaching for middle school, high school, and
            college students. Skill-building, confidence, and a clear path
            forward.
          </p>
          <p className="mt-4 text-sm text-[var(--color-cream)]/60">
            Megan Lane · Florida-based, virtual nationwide
            <br />
            <a
              href="mailto:megan@yourlanecoaching.com"
              className="text-[var(--color-cream)] underline"
            >
              megan@yourlanecoaching.com
            </a>
          </p>
        </div>

        <div className="md:col-span-4">
          <p className="eyebrow text-[var(--color-tan)]">Sitemap</p>
          <ul className="mt-4 space-y-2">
            {sitemap.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-sm text-[var(--color-cream)]/90 underline-offset-4 hover:text-[var(--color-cream)] hover:underline"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="eyebrow text-[var(--color-tan)]">Legal</p>
          <ul className="mt-4 space-y-2">
            {legal.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-sm text-[var(--color-cream)]/90 underline-offset-4 hover:text-[var(--color-cream)] hover:underline"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
          <p className="mt-6 text-xs text-[var(--color-cream)]/50" aria-hidden>
            {/* social placeholder per PRD §4 */}
            Social channels coming in Phase 2.
          </p>
        </div>
      </Container>

      <div className="border-t border-[var(--color-cream)]/10">
        <Container className="flex flex-col items-start justify-between gap-3 py-6 text-xs text-[var(--color-cream)]/60 sm:flex-row sm:items-center">
          <p>© {year} Your Lane, LLC. All rights reserved.</p>
          <p>Built with care in Florida.</p>
        </Container>
      </div>
    </footer>
  );
}
